import $foreign from "./foreign.cjs";
var _charAt = $foreign._charAt;
var _indexOf = $foreign._indexOf;
var _indexOfStartingAt = $foreign._indexOfStartingAt;
var _lastIndexOf = $foreign._lastIndexOf;
var _lastIndexOfStartingAt = $foreign._lastIndexOfStartingAt;
var _slice = $foreign._slice;
var _toChar = $foreign._toChar;
var countPrefix = $foreign.countPrefix;
var drop = $foreign.drop;
var fromCharArray = $foreign.fromCharArray;
var length = $foreign.length;
var singleton = $foreign.singleton;
var splitAt = $foreign.splitAt;
var take = $foreign.take;
var toCharArray = $foreign.toCharArray;
export { _charAt, _indexOf, _indexOfStartingAt, _lastIndexOf, _lastIndexOfStartingAt, _slice, _toChar, countPrefix, drop, fromCharArray, length, singleton, splitAt, take, toCharArray };
